<template>
    <v-row>
        <v-col cols="12" md="3" class="mt-4">
            <h4 class="my-text-black">Datos del profesional prescriptor</h4>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12" md="6">
            <v-text-field
                required
                class="asterisco"
                clearable
                :rules="obligatorioNumerico"
                label="Matricula"
                variant="solo"
                v-model="matriculaPrescriptor"
                @update:modelValue="actualizarProfesionalPrescriptor"
                >
            </v-text-field>
        </v-col>
        <v-col cols="12" md="6">
            <v-select
                v-model="tipoMatriculaSeleccionada"
                :items="tiposDeMatriculas"
                label="Tipo matrícula"
                variant="solo"
                class="asterisco"
                clearable
                required
                :rules="obligatorio"
            ></v-select>
        </v-col>
    </v-row>
    <v-select
        v-model="profesionSeleccionada"
        :items="profesiones"
        label="Profesión"
        variant="solo"
        item-title="descripcion"
        return-object
        :loading="cargandoProfesiones"
        class="asterisco"
        required
        :rules="obligatorio"
        clearable
        @update:modelValue="actualizarProfesion"
    ></v-select>
    <v-text-field
        required
        class="asterisco"
        clearable 
        :rules="obligatorioAlfabetico"
        label="Apellido y nombre" 
        variant="solo"
        v-model="prescriptor.nombreApellidoPrescriptor"
    >
    </v-text-field>
</template>
<style src="../assets/general.css"></style>
<script>
    /* eslint-disable */
    import { obligatorioAlfabetico, obligatorioNumerico, obligatorio } from '@/_helpers/rules';
    import FacturadorService from '@/api/FacturadorService';
    import ProfesionalService from '@/api/ProfesionalService';

    const facturadorService = new FacturadorService();
    const profesionalService = new ProfesionalService();

    export default {
        data() {
            return {
                obligatorioAlfabetico : obligatorioAlfabetico,
                obligatorioNumerico : obligatorioNumerico,
                obligatorio : obligatorio,
                matriculaPrescriptor: null,
                prescriptor: {
                    matriculaPrescriptor: null,
                    nombreApellidoPrescriptor: null,
                    tipoMatricula: null,
                },
                profesionalesFacturador: [],
                tiposDeMatriculas: ['Matrícula Provincial', 'Matrícula Nacional'],
                cargandoProfesionales: false,
                tipoMatriculaSeleccionada: null,
                profesiones: [],
                profesionSeleccionada: null,
                cargandoProfesiones: false,
            }
        },
        computed: {
        },
        async mounted(){
            await this.cargarProfesionalesFacturador();
            await this.cargarProfesiones();
        },
        methods: {
            actualizarProfesionalPrescriptor() {
                if(this.matriculaPrescriptor){
                    const profesionalPrescriptor = this.profesionalesFacturador.find(p => p.matriculaProvincial == this.matriculaPrescriptor);
                    if(profesionalPrescriptor){
                        this.prescriptor.nombreApellidoPrescriptor = profesionalPrescriptor.apellidos + ' ' + profesionalPrescriptor.nombres;
                        this.tipoMatriculaSeleccionada = this.tiposDeMatriculas[0];
                        this.prescriptor.tipoMatricula = 'MP';
                        this.prescriptor.matriculaPrescriptor = this.matriculaPrescriptor;
                    }
                    else{
                        profesionalPrescriptor = this.profesionalesFacturador.find(p => p.matriculaNacional == this.matriculaPrescriptor);
                        if(profesionalPrescriptor){
                            this.prescriptor.nombreApellidoPrescriptor = profesionalPrescriptor2.apellidos + ' ' + profesionalPrescriptor2.nombres;
                            this.tipoMatriculaSeleccionada = this.tiposDeMatriculas[1];
                            this.prescriptor.tipoMatricula = 'MN';
                            this.prescriptor.matriculaPrescriptor = this.matriculaPrescriptor;
                        }
                        else{
                            this.prescriptor.tipoMatricula = (this.tipoMatriculaSeleccionada == tiposDeMatriculas[0]) ? 'MP' : 'MN';
                            this.prescriptor.matriculaPrescriptor = this.matriculaPrescriptor;
                        }
                    }
                    this.$emit('actualizar-prescriptor', this.prescriptor);
                }
            },
            actualizarProfesion(){
                if(this.profesionSeleccionada){
                    this.$emit('actualizar-profesion', {profesion: this.profesionSeleccionada});
                }
            },
            async cargarProfesionalesFacturador(){
                this.cargandoProfesionales = true;
                const response = await facturadorService.getProfesionalesFacturador(this.$store.getters.getFacturador.id);
                if(response.status == 200){
                    this.profesionalesFacturador = response.data;
                }
                this.cargandoProfesionales = false;
            },
            async cargarProfesiones(){
                this.cargandoProfesiones = true;
                const response = await profesionalService.getProfesiones();
                if(response.status == 200){
                    this.profesiones = response.data;
                }
                this.cargandoProfesiones = false;
            },
        },
    }
</script>